/* eslint-disable max-len */
import React from 'react';

const AddMediaIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10.0001V13.0001C5 13.5524 5.44772 14.0001 6 14.0001H13C13.5523 14.0001 14 13.5524 14 13.0001V10.0001H15V13.0001C15 14.1046 14.1046 15.0001 13 15.0001H6C4.89543 15.0001 4 14.1046 4 13.0001V10.0001H5ZM9 4.70521L6.84604 6.85697C6.65262 7.0502 6.33919 7.05012 6.14586 6.85679C5.95249 6.66342 5.95229 6.34996 6.14541 6.15633L9.5 2.79297L12.8517 6.15619C13.0448 6.34992 13.0445 6.66339 12.8511 6.85679C12.6578 7.05009 12.3444 7.05006 12.1512 6.85676L10 4.70521V12.0001H9V4.70521Z"
      fill="#000624"
    />
  </svg>
);

export default AddMediaIcon;
